/** Role as carried in the permission-sync payload. */
export interface SyncedRole {
  id: number;
  name: string;
  role_access_type?: { slug: string | null };
}

/** Response body of GET /api/v1/auth/user/permissions-sync (the `data` key). */
export interface PermissionSyncPayload {
  permissions: string[];
  roles: SyncedRole[];
  is_super_admin: number;
  family_root_id: number | null;
  /**
   * Environment namespace for Signal Bus paths, chosen by the SERVER.
   * Optional: a frontend may briefly talk to a backend that predates this field.
   */
  signal_namespace?: string | null;
  user_id: number;
  /** Server emit time in epoch ms — guards against out-of-order responses. */
  issued_at: number;
}

/** localStorage keys the permission store owns. Kept as-is for back-compat. */
export const PERMISSION_STORAGE_KEYS = {
  permissions: '_userPermissions',
  roles: '_currentUserRoles',
  isSuperAdmin: '_currentUserIsSuperAdmin',
} as const;
